import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import useScreen from 'hooks/useScreen';
import SliderComponent from './SliderComponent';

const CardCarousel = props => {
  const {
    afterSlideFn,
    beforeSlideFn,
    children,
    deviceOverride,
    disableSliding,
    fabricGridControls = false,
    imageHeight,
    imageWidth,
    isMobileMaterialSwatches = false,
    navType,
    slideIndex,
    variant,
    visibleSlides,
    fullHeight = false,
  } = props;

  let finalVisibleSlides = visibleSlides
    ? visibleSlides.content
      ? visibleSlides.content
      : visibleSlides
    : 2;

  const { isMobile } = useScreen();

  if (isMobile && !isMobileMaterialSwatches) {
    finalVisibleSlides = 1;
  }

  return (
    <div
      className={classNames({
        '[&_.slider-slide]:!min-h-[400px] [&_.slider-slide]:!h-full [&_.slider-slide]:max-[569px]:!min-h-[275px] [&_.slider-list]:max-[568px]:!overflow-y-scroll':
          variant === 'reviews-list',
      })}
    >
      <SliderComponent
        afterSlideFn={afterSlideFn}
        beforeSlideFn={beforeSlideFn}
        deviceOverride={deviceOverride}
        disableSliding={disableSliding}
        fabricGridControls={fabricGridControls}
        finalVisibleSlides={finalVisibleSlides}
        imageHeight={imageHeight}
        imageWidth={imageWidth}
        isMobileMaterialSwatches={isMobileMaterialSwatches}
        navType={navType}
        slideIndex={slideIndex}
        variant={variant}
        fullHeight={fullHeight}
      >
        {children}
      </SliderComponent>
    </div>
  );
};
CardCarousel.propTypes = {
  afterSlideFn: PropTypes.func,
  beforeSlideFn: PropTypes.func,
  children: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.string,
      url: PropTypes.string,
      value: PropTypes.string,
    })
  ),
  deviceOverride: PropTypes.bool,
  disableSliding: PropTypes.bool,
  fabricGridControls: PropTypes.bool,
  imageHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  imageWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isMobileMaterialSwatches: PropTypes.bool,
  navType: PropTypes.string,
  slideIndex: PropTypes.number,
  variant: PropTypes.oneOf([
    'blog-slider',
    'collections-slider',
    'material-swatches-sidebar',
    'reviews-list',
  ]),
  visibleSlides: PropTypes.number,
  fullHeight: PropTypes.bool,
};

export default CardCarousel;
